import useU2000AxiosNonAuthenticated from '../../axios/U2000UseAxiosNonAuthenticated';

const GOOGLE_SSO_STATUS_URL = 'U2001/googleSsoStatus';

export type U2000GoogleSsoStatusResult = {
  googleSsoAvailable: boolean;
};

type GoogleSsoStatusFn = () => Promise<U2000GoogleSsoStatusResult>;

/** BL-0517 / BL-0520 — disponibilité SSO Google côté serveur (alerte admin). */
const useU2000GoogleSsoStatus = (): GoogleSsoStatusFn => {
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doGetGoogleSsoStatus: GoogleSsoStatusFn = async () => {
    const response = await u2000AxiosNonAuthenticated.get(GOOGLE_SSO_STATUS_URL);
    return response.data as U2000GoogleSsoStatusResult;
  };

  return doGetGoogleSsoStatus;
};

export default useU2000GoogleSsoStatus;
